import React from 'react';
import PropTypes from 'prop-types';
import { Modal as BootstrapModal } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Modal({ children, className, icon, show, size, title, onHide }) {
  return (
    <BootstrapModal className={`ds-modal ${className}`} show={show} size={size} onHide={onHide}>
      <BootstrapModal.Header>
        <BootstrapModal.Title className="d-flex text-center gap-2 align-items-center">
          {icon && <FontAwesomeIcon className="text-primary" icon={icon} />}
          {title}
        </BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body className="modal-padding overflow-auto">
        {children}
      </BootstrapModal.Body>
    </BootstrapModal>
  );
}

export function Footer({ children, footerOrientation }) {
  const footerOrientationClass = () => {
    switch (footerOrientation) {
    case 'center':
      return 'text-center';
    case 'left':
      return 'text-start';
    case 'right':
      return 'text-end';
    }
  };

  return (
    <div className={`${footerOrientationClass()} mt-5`}>
      {children}
    </div>
  );
}

Footer.propTypes = {
  children: PropTypes.node,
  closeButtonText: PropTypes.string,
  footerOrientation: PropTypes.oneOf(['left', 'right', 'center']),
  onHide: PropTypes.func
};

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.object,
  show: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string,
  onHide: PropTypes.func
};

Modal.Footer = Footer;
export default Modal;
